import { render } from "./update-stackholder.vue?vue&type=template&id=641dc20a&scoped=true"
import script from "./update-stackholder.vue?vue&type=script&lang=js"
export * from "./update-stackholder.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./update-stackholder.vue?vue&type=style&index=1&id=641dc20a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641dc20a"]])

export default __exports__